import {
	getAction
} from '@/api/index';
export default {
	data() {
		return {
			url: {
				list: "/officialWebsite/c-api/coreTechnology/list",
			},
			dataList: []
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		async loadData() {
			const res = await getAction(this.url.list);
			if (res.success) {
				this.dataList = res.result;
			}
		},
		onClickItem(id) {
			this.$router.push({
				path: '/detail?type=tec&id=' + id
			});
		},
	}
}